import {
  CenterLocalOrganizer,
  CenterLocalOrganizerInput
} from '../../../lib/types/models/center/center-local-organizer'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function updateCenterLocalOrganizers(id: number, data: CenterLocalOrganizerInput[]) {
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterLocalOrganizers.url, { id }))
    .patch<CenterLocalOrganizer[], CenterLocalOrganizerInput[]>(data)
}
